import logo_white from '../assets/images/logo_white.png'
import bg_login from '../assets/images/bg-login.png'
import icon_avatar from '../assets/images/icon_avatar.png'
import no_data from '../assets/images/no_data.png'
import image_not_found from '../assets/images/image_not_found.png'
import ic_close_circle from '../assets/images/ic_close_circle.png'
import ic_clock from '../assets/images/ic_clock.png'
import ic_plus from '../assets/images/ic_plus.png'
import ic_edit from '../assets/images/ic_edit.png'
import ic_caret_down from '../assets/images/ic_caret_down.png'
import ic_caret_up from '../assets/images/ic_caret_up.png'
import ic_upload from '../assets/images/ic_upload.png'
import ic_camera from '../assets/images/ic_camera.png'
import ic_filter from '../assets/images/filter-icon.svg'
import ic_user from '../assets/images/user.svg'
import ic_history from '../assets/images/history.svg'
import ic_chart from '../assets/images/chart-bar.svg'
import ic_ticket from '../assets/images/ticket.svg'
import logout from '../assets/images/logout.png'
import chat_support from '../assets/images/chat-support.png'
import ic_copy from '../assets/images/ic_copy.png'
import ic_bell from '../assets/images/ic_bell.png'
import ic_product_features from '../assets/images/svg/ic_product-features.svg'
import ic_config_product_type from '../assets/images/svg/ic_config-product-type.svg'
import ic_history_impact from '../assets/images/svg/ic_history-impact.svg'
import ic_history_sync from '../assets/images/svg/ic_history-sync.svg'
import ic_manage_packages from '../assets/images/svg/ic_manage-packages.svg'
import ic_manage_value_added_services from '../assets/images/svg/ic_manage-value-added-services.svg'
import ic_manage_ftth from '../assets/images/svg/ic_manage-ftth.svg'
import ic_manage_sim from '../assets/images/svg/ic_manage-sim.svg'
import ic_manage_card from '../assets/images/svg/ic_manage-card.svg'
import ic_manage_product_device from '../assets/images/svg/ic_manage-product-device.svg'
import ic_manage_sales_channel from '../assets/images/svg/ic_manage-sales-channel.svg'
import ic_manage_banner from '../assets/images/svg/ic_manage-banner.svg'
import ic_product_category from '../assets/images/svg/ic_product-category.svg'
import ic_user_default from '../assets/images/icon_avatar.png'
import ic_dot from '../assets/images/svg/ic_dot.svg'
import ic_arrrow_right from '../assets/images/svg/ic_arrrow-right.svg'
import ic_arrow_right_small from '../assets/images/ic_arrow_right.svg'
import ic_arrow_right_small_active from '../assets/images/ic_arrow_right_active.svg'
import ic_logo from '../assets/images/ic_logo.svg'
import bg from '../assets/images/bg.svg'
import ic_web_service from '../assets/images/svg/ic_web_service.svg'
import ic_digital_service from '../assets/images/svg/ic_digital_service.svg'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
   ic_web_service,
   ic_digital_service,
   bg,
   ic_logo,
   chat_support,
   logout,
   ic_ticket,
   ic_chart,
   ic_history,
   ic_user,
   logo_white,
   bg_login,
   icon_avatar,
   no_data,
   image_not_found,
   ic_close_circle,
   ic_clock,
   ic_plus,
   ic_edit,
   ic_caret_down,
   ic_caret_up,
   ic_upload,
   ic_camera,
   ic_filter,
   ic_copy,
   ic_bell,
   ic_product_features,
   ic_config_product_type,
   ic_history_impact,
   ic_history_sync,
   ic_manage_packages,
   ic_manage_value_added_services,
   ic_manage_ftth,
   ic_manage_sim,
   ic_manage_card,
   ic_manage_product_device,
   ic_manage_sales_channel,
   ic_manage_banner,
   ic_product_category,
   ic_user_default,
   ic_dot,
   ic_arrrow_right,
   ic_arrow_right_small,
   ic_arrow_right_small_active
}
